import { documentsApprovalList } from "constants/documentsApproval";
import * as api from "../API/index";
import { authorizedUser } from "components/CommonComponents/CommonFunctions";
export const getDocumentsApprovalList = async (
  dispatch,
  pageNum,
  filterParams
) => {
  try {
    const res = await api.get_pending_document_approvals(
      pageNum,
      filterParams
    );

    dispatch({
      type: documentsApprovalList,
      payload: res?.data,
    });
  } catch (error) {
    authorizedUser(error?.response?.data);

    dispatch({
      type: documentsApprovalList,
      payload:
        error?.response?.data ?? { message: error?.message },
    });
  }
};